import React, { Component } from 'react';

//Custom Components
import Header from '../components/Header'
import SingleAppShowCase from '../components/SingleAppShowcase'
import Hero from '../components/Hero'

// Hero Image
import invoHero from '../img/optimized/powershades_office.jpeg'

// Images for Demo
import pssc from '../img/ps-screenshot.png'


// Images for Logo
import PSLogo from '../img/ps-logo.png'



class Powershades extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  render() {
    return (
      <div
        className="align-items-center"
      >
         <Header
          title="PowerShades"
          backgroundColor={'#EEE'}
          textColor={'#000'}
          jobTitle={'Mobile Applications Developer'}
          yearsAtRole={"2020"}
        /> 
        <Hero
          heroBackground={invoHero}
          jobTitle={"Software Engineer (Contract)"}
          companyName={"Powershades"}
          darkArrow={true}
          yearsActive={"2020"}
        />
        <SingleAppShowCase
          backgroundColor={'#FFF'}
          // appTitle={"PowerShades"}
          appLogo={PSLogo}
          logoWidth={"50%"}
          extraPadding={'15%'}
          appDescription="Powershades is a mobile platform for clients of the motorized shades company to be able to quickly modify
                          their shades from anywhere. Using the application grants users the ability to connect new shades, 
                          easily group shades together for simplistic scheduling and monitoring.
                          I worked on the engineering team to provide updates on the app including performance imporvements and bug fixes. 
                          I later got to develop a prototype of a redesigned version of the app featuring a more modern UX.
                          "
          appVisual={pssc}
          appStoreLink="https://apps.apple.com/us/app/powershades/id1509601683#?platform=iphone"
        /> 
      </div>
    );
  }
}

export default Powershades;



// WEBPACK FOOTER //
// ./src/screens/PowerShades.js